// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GET_DASHBOARD as ACTION_MONDOO_BI_BIDASHBOARDSERVICE_GETDASHBOARD } from "~/lib/iam/actions/mondoo/bi/BIDashboardService/GetDashboard/action";
import { GET_VERSION as ACTION_MONDOO_BI_BIDASHBOARDSERVICE_GETVERSION } from "~/lib/iam/actions/mondoo/bi/BIDashboardService/GetVersion/action";
import { LIST_DASHBOARDS as ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTDASHBOARDS } from "~/lib/iam/actions/mondoo/bi/BIDashboardService/ListDashboards/action";
import { LIST_SCHEDULED_EXPORTS as ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTSCHEDULEDEXPORTS } from "~/lib/iam/actions/mondoo/bi/BIDashboardService/ListScheduledExports/action";
import { LIST_VERSIONS as ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTVERSIONS } from "~/lib/iam/actions/mondoo/bi/BIDashboardService/ListVersions/action";

export const allowedActions = [
  ACTION_MONDOO_BI_BIDASHBOARDSERVICE_GETDASHBOARD,
  ACTION_MONDOO_BI_BIDASHBOARDSERVICE_GETVERSION,
  ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTDASHBOARDS,
  ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTSCHEDULEDEXPORTS,
  ACTION_MONDOO_BI_BIDASHBOARDSERVICE_LISTVERSIONS,
] as const;
